'use client';

import { useState, useEffect } from 'react';
import { Button } from './Button';
import { useI18n } from '@/i18n/I18nProvider';
import type { Locale } from '@/i18n';

export function LanguageToggle() {
    const { locale, setLocale, t } = useI18n();
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);

    const toggleLanguage = () => {
        const newLocale: Locale = locale === 'de' ? 'en' : 'de';
        setLocale(newLocale);
    };

    if (!mounted) {
        return (
            <Button variant="ghost" size="icon" className="h-9 w-9 text-sm font-medium">
                DE
            </Button>
        );
    }

    return (
        <Button
            variant="ghost"
            size="icon"
            onClick={toggleLanguage}
            aria-label={locale === 'de' ? t('language.switchToEnglish' as any) : t('language.switchToGerman' as any)}
            className="h-9 w-9 text-sm font-medium"
        >
            {locale === 'de' ? 'EN' : 'DE'}
        </Button>
    );
}
